import { render, staticRenderFns } from "./SandboxTemplate.vue?vue&type=template&id=c38861ce&scoped=true&"
import script from "./SandboxTemplate.vue?vue&type=script&lang=js&"
export * from "./SandboxTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SandboxTemplate.vue?vue&type=style&index=0&id=c38861ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38861ce",
  null
  
)

export default component.exports